
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DebugViewComponent } from './debug-view.component';

@Component({
    selector: 'app-debug-split-view',
    standalone: true,
    imports: [DebugViewComponent],
    templateUrl: './debug-split-view.component.html',
    styleUrls: ['./debug-split-view.component.scss']
})
export class DebugSplitViewComponent implements OnInit {
    public sanitizedPreviewUrl: SafeResourceUrl = '';
    public botId = '';
    public leftWidthPercent = 60;
    public isDragging = false;

    private dragStartX = 0;
    private dragStartWidth = 0;
    private containerWidth = 0;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) { }

    public ngOnInit(): void {
        this.botId = this.route.snapshot.params['id'] as string;
        const rawUrl = this.route.snapshot.queryParams['previewUrl'] as string | undefined;
        if (rawUrl) {
            this.sanitizedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                decodeURIComponent(rawUrl)
            );
        }
    }

    public startDrag(event: MouseEvent, container: HTMLElement): void {
        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragStartWidth = this.leftWidthPercent;
        this.containerWidth = container.offsetWidth;
        event.preventDefault();
    }

    @HostListener('document:mousemove', ['$event'])
    public onMouseMove(event: MouseEvent): void {
        if (!this.isDragging) return;
        const deltaX = event.clientX - this.dragStartX;
        const deltaPercent = (deltaX / this.containerWidth) * 100;
        this.leftWidthPercent = Math.min(85, Math.max(15, this.dragStartWidth + deltaPercent));
    }

    @HostListener('document:mouseup')
    public onMouseUp(): void {
        this.isDragging = false;
    }
}
